function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 3.606,
  width: 7.753,
  height: 7.753,
  rx: 2,
  fill: "#0073FF"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 13.933,
  width: 7.753,
  height: 7.753,
  rx: 2,
  fill: "#0073FF"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  "data-figma-bg-blur-radius": 10,
  x: 16.235,
  y: 2,
  width: 7.753,
  height: 7.753,
  rx: 2,
  transform: "rotate(45 16.235 2)",
  fill: "#0073FF",
  fillOpacity: 0.3
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 12.358,
  y: 13.933,
  width: 7.753,
  height: 7.753,
  rx: 2,
  fill: "#0073FF"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "workplate-active_svg__bgblur_1_486_1750_clip_path"
}, /*#__PURE__*/React.createElement("rect", {
  x: 16.235,
  y: 2,
  width: 7.753,
  height: 7.753,
  rx: 2,
  transform: "rotate(45 16.235 2)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "workplate-active_svg__clip0_486_1750"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})));

var SvgWorkplateActive = function SvgWorkplateActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#workplate-active_svg__clip0_486_1750)"
  }, _ref, _ref2, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5px)",
      height: "100%",
      width: "100%"
    },
    clipPath: "url(#workplate-active_svg__bgblur_1_486_1750_clip_path)"
  })), _ref3, _ref4), _ref5);
};

export default SvgWorkplateActive;